import { Clapperboard, Film, Sparkles, Video, type LucideIcon } from 'lucide-react';

/**
 * Icons a service may name in `configSchema.ui.icon`. Explicit map (not the whole lucide
 * registry) keeps the bundle small; unknown names fall back to Sparkles.
 */
const SERVICE_ICONS: Record<string, LucideIcon> = {
  Video,
  Clapperboard,
  Film,
  Sparkles,
};

export function serviceIcon(name: string): LucideIcon {
  return SERVICE_ICONS[name] ?? Sparkles;
}
